import styled from 'styled-components';

export const LOGO_TITLE_KEY = 'plkLogoTitle';

export const StyledLogo = styled.div`
  width: 34.15px;
  /** Safari/WkWebView doesn't display the image without the height */
  height: 40px;
  display: flex;

  @media (min-width: 431px) and (max-width: 1199px) {
    width: 150px;
    height: 42px;
  }

  ${Styles.desktopLarge} {
    height: 42px;
    width: 150px;
    z-index: ${Styles.zIndex.top};
  }
`;
